import {SET_TIMEZONE_ID, SET_TIMEZONE_TEXT, SET_CURRENCY, SET_COUNTRY_MARKET} from "@/store/mutation-types";


const state = {
    timezoneId: '', // 时区id
    timezoneText: '', // 时区时间
    dashboardCurrency: 'USD', // 币种
    countryMarket: {
        countryIds:[],
        marketIds:[]
    }
};

const mutations = {
    [SET_TIMEZONE_ID](state, timezoneId) {
        state.timezoneId = timezoneId
    },
    [SET_TIMEZONE_TEXT](state, timezoneText) {
        state.timezoneText = timezoneText
    },
    [SET_CURRENCY](state, currency) {
        state.dashboardCurrency = currency
    },
    [SET_COUNTRY_MARKET](state, countryMarket) {
        state.countryMarket = countryMarket
    },
};

const actions = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}